<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  pdf: string
  alt?: string
  width?: number
  height?: number
}>()

const emit = defineEmits(['ready'])

const config = useRuntimeConfig()

const src = ref()

const url = `${config.public.directusUrl}/assets/${props.pdf}`

onMounted(async () => {
  const pdfjs = await import('pdfjs-dist')

  const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.min?url')

  pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker.default

  try {
    await pdfjs.getDocument({ url, wasmUrl: '/wasm/' })
      .promise
      .then(async (pdf) => {
        await pdf.getPage(1).then(async (page) => {
          const canvas = document.createElement('canvas')
          let viewport = page.getViewport({ scale: 1.0 })
          const context = canvas.getContext('2d')!

          if (props.width) {
            viewport = page.getViewport({
              scale: props.width / viewport.width,
            })
          }
          else if (props.height) {
            viewport = page.getViewport({
              scale: props.height / viewport.height,
            })
          }

          canvas.height = viewport.height
          canvas.width = viewport.width

          await page.render({
            canvas: null,
            canvasContext: context,
            viewport,
          }).promise.then(() => {
            src.value = canvas.toDataURL()
          })
        })
      })

    emit('ready')
  }
  catch {}
})
</script>

<template>
  <TransitionFade>
    <img
      v-if="src"
      :src
      :alt
      v-bind="$attrs"
      class="ics-u69aqk"
    >
  </TransitionFade>
</template>
